export default {
  aws_project_region: 'eu-central-1',
  aws_cognito_identity_pool_id: 'eu-central-1:e38be394-4691-4075-a5b2-e18bff881d32',
  aws_cognito_region: 'eu-central-1',
  aws_user_pools_id: 'eu-central-1_CsLR12nXI',
  aws_user_pools_web_client_id: 'flf30asja45qtti4nvum9f6po',
  oauth: {}
};
